import React from 'react'

function HowitworksAttorneyAssistant() {
    const howItworksObj = [{
        "title": "Step 1A",
        "description":"Assistant creates a username and password and then logs onto the platform.",
        "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItWorksAttAndAssistant/1A.png", 
        ]
      },
      {
        "title": "Step 1B",
        "description":"Assistant fills in profile information.",
        "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItWorksAttAndAssistant/1B.png", 
        ]
      },
        {
            "title": "Step 1C",
            "description":"Assistant accesses the “Attorneys” section on their account and fills in Attorney’s email address to request access to Attorney’s case dashboard. Assistant’s email domain name will have to match Attorney’s email domain name. The “gmail.com” email address below is for exemplary purposes only. Alternatively, Attorney can directly search for Assistant as shown in subsequent steps.",
            "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItWorksAttAndAssistant/1C.png", 
            ]
        },
        {
            "title": "Step 2A",
            "description":"Attorney accesses the “Team management” section of their profile.",
            "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItWorksAttAndAssistant/2A.png", 
            ]
        },
        {
            "title": "Step 2B",
            "description":"Attorney searches for Assistant by email address. Attorney can only search for email addresses with the same domain name as that associated with Attorney. The “gmail.com” email address below is for exemplary purposes only.",
            "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItWorksAttAndAssistant/2B.png", 
            ]
        },
        {
            "title": "Step 2C",
            "description":"Upon selecting “Find Assistant” after entering Assistant’s email address, Assistant’s name is shown.",
            "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItWorksAttAndAssistant/2C.png", 
            ]
        },
        {
            "title": "Step 2D",
            "description":"Upon selecting “Add to team,” Assistant is added to Attorney’s Assistants list.",
            "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItWorksAttAndAssistant/2D.png", 
            ]
        },
        {
            "title": "Step 3A",
            "description":"Assistant is notified that Assistant can start acting on behalf of Attorney.",
            "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItWorksAttAndAssistant/3A.png", 
            ]
        },
        {
            "title": "Step 3B",
            "description":"In the “Attorneys” section of Assistant’s profile, Assistant can now see that Assistant has approved access to Attorney’s case dashboard.",
            "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItWorksAttAndAssistant/3B.png", 
            ]
        },
        {
            "title": "Step 3C",
            "description":"Assistant can navigate to the list of attorneys that Assistant is acting on behalf of.",
            "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItWorksAttAndAssistant/3C.png"],
        },
        {
            "title": "Step 3D",
            "description":"Assistant can select the option from Step 3C to navigate to Attorney’s case dashboard.",
            "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItWorksAttAndAssistant/3D.png",]
        }
    ];
    
    return (
        <div className='px-2 lg:p-10 lg:px-20 bg-gray-100'>
          <div className='font-bold text-sm lg:text-3xl text-gray-700 text-center mb-14 mt-10'>
          A Quick Guide for Attorneys and Assistants to understand how our website works 
          </div> 

          <div className='text-gray-900 text-left mb-4 mt-10'>
            <div>
                {howItworksObj.map((item, index) => {
                    return (
                        <div key={index} className='flex flex-col mb-4 text-sky-900 mt-2'>
                            <div className='lg:text-xl text-sm font-bold flex item-end mb-3 w-full mt-10'>{item.title} : {item.description}</div>
                            
                            {item?.img?.map((img, index) => {
                                return (
                                    <div key={index} className='flex justify-center  lg:p-20 border border-sky-800 rounded shadow-lg mt-10'>
                                        <img src={img} alt={item.title} className='rounded border ' />
                                    </div>
                                )
                            })}
                        </div>
                    )
                })}
            </div>
          </div>
        </div>
    );
}

export default HowitworksAttorneyAssistant
